<template>
  <div :class="`program${isMobile ? ' program-mobile' : ''}`" v-show="!isMobile">
    <div class="title">
      <h1 class="tit">{{ title }}</h1>
      <h4 class="subtitle">{{ subtitle }}</h4>
    </div>
    <div class="content">
      <!-- <div class="more">
        <a href="javascript:;"> 查看全部 <i class="el-icon-caret-right" /> </a>
      </div> -->
      <div class="left">
        <img v-show="adsPictures" :src="adsPictures" alt="adsPictures" />
        <i v-show="!adsPictures" class="el-icon-circle-plus" style="color: #666; font-size: 4em" />
      </div>
      <div class="right">
        <a href="javascript:;" class="item" v-show="lists.length > 0" v-for="(item, index) in lists" :key="index">
          <img :src="item.src" />
          <span v-text="item.title" />
          <span v-text="item.subtitle" />
        </a>
        <div class="item" v-show="lists.length < 8">
          <i class="el-icon-circle-plus" style="color: #666; font-size: 4em" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _isMobile } from '@/utils/config';

export default {
  name: 'program',
  // 与父组件通信
  props: {
    title: { type: String, default: '未设置标题' },
    subtitle: { type: String, default: '未设置子标题' },
    adsPictures: { type: String, required: true },
    lists: { type: Array, required: true },
  },
  // 组件
  components: {},
  // 数据
  data() {
    return {
      isMobile: _isMobile(),
    };
  },
  // 监听
  watch: {},
  // 挂载结束状态
  mounted() {},
  // 方法
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import './index.less';
</style>

